import React from 'react'
import { PropTypes } from 'prop-types'
import { Grid, Row, Col } from 'react-flexbox-grid';
import { HtmlHead, PageWrapper, PageContent, Footer, BurgerMenu } from '../../ui'
import bem from '../../../common/bem'
import { checkIsError } from '../../../common/genericHelper'

import './BuildPage.scss'

export default class DefaultPage extends React.Component {

  static defaultProps = {
    onMenuChange: () => {},
    curMenuState: false
  }

  static propTypes = {
    route: PropTypes.object,
    curMenuState: PropTypes.bool,
    onMenuChange: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  componentWillMount() {
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  componentWillUpdate() {
    !this.props.curMenuState && this.props.onMenuChange && this.props.onMenuChange(null, true);
  }

  render() {
    const { curMenuState, onMenuChange, route } = this.props;
    const { title } = route;
    const isError = checkIsError(this.props);

    if(isError) this.context.router.push('/404');

    const bemmer = bem('buildpage');

    return(
      <PageWrapper isSidebarOpen={this.props.curMenuState}>
        <HtmlHead title={title} />
        <PageContent>
          <BurgerMenu curMenuState={curMenuState} onMenuChange={onMenuChange} />
          <Row>
            <Col md={8}>
            <h1>Build</h1>

            <p>SLS Zone open source projects which are available for you to use as part of a larger project.
              You are welcome to submit pull requests, leave feature suggestions on the issues tracker,
              or just use within your own project to save you the development time.
            </p>

            <p>All projects here are used daily the by Reason development team, are maintained,
              and battle tested through production implementation. But new use cases always come up,
              so feel free to let us know where they can improve.</p>

            <Row>
              <Col md={6} sm={6}>
                  <div className={bemmer.element('tile')}>
                    <h3 className={bemmer.element('tile-heading-2')}>slspress</h3>
                    <div className={bemmer.element('tile-content')}>
                      <p>A clean and clear way to structure your API endpoints, and Serverless architecture regardless of nano,
                        micro or monolith. Based on express, introduces middleware and components into the serverless domain.
                        No dependencies, lean and functional.</p>
                        <div className="icons">
                          <a href="https://github.com/withreason/slspress">
                            <img alt="Git Hub" src="/images/logo-github-small.png"/>
                          </a>
                        </div>
                    </div>
                  </div>
              </Col>
              <Col md={6} sm={6}>
                <div className={bemmer.element('tile')}>
                  <h3 className={bemmer.element('tile-heading-1')}>dumptruck</h3>
                  <div className={bemmer.element('tile-content')}>
                    <p>Very practical and useful AWS log streaming tool. You will find this invaluable when working with
                      remotely deployed lambda’s, and needing to view AWS Cloud Watch at runtime.</p>
                      <div className="icons">
                        <a href="https://github.com/withreason/dumptruck">
                          <img alt="Git Hub" src="/images/logo-github-small.png"/>
                        </a>
                      </div>
                  </div>
                </div>
              </Col>
              </Row>

              <Row>
                <Col md={6} sm={6}>
                  <div className={bemmer.element('tile')}>
                    <h3 className={bemmer.element('tile-heading-3')}>sls-notify</h3>
                    <div className={bemmer.element('tile-content')}>
                      <p>Managing your notification from 10 to >10,000,000. Sls-notify is built to make your communication
                        layer easy to implement and grow to new devices as you project expands. Supports Email,
                        SMS, APNS, GCM, and MPNS. Build on top of AWS Elastic Search, SES, & SNS.
                      </p>
                      <div className="icons">
                        <a href="https://github.com/withreason/sls-notify">
                          <img alt="Git Hub" src="/images/logo-github-small.png"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6} sm={6}>
                  <div className={bemmer.element('tile')}>
                    <h3 className={bemmer.element('tile-heading-4')}>sls-image-cdn</h3>
                    <div className={bemmer.element('tile-content')}>
                      <p>Add CDN functionality to your Serverless application. sls-cdn will help you create signed uploads,
                        and provide on-demand image transformations and file tagging. Built on top of S3 and Cloudfront.
                      </p>
                      <div className="icons">
                        <a href="https://github.com/withreason/sls-image-cdn">
                          <img alt="Git Hub" src="/images/logo-github-small.png"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              </Col>
              </Row>
        </PageContent>
        <Footer />
      </PageWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./component/page/BuildPage/BuildPage.js